/**
 * Push error
 * @category Graph
 */
export class PushError extends Error {
  constructor(frameUID, nodeUID, error) {
    super();
    this.frameUID = frameUID;
    this.nodeUID = nodeUID;
    this.name = error.name;
    this.message = error.message;
    this.stack = error.stack;
  }
}